import { render, staticRenderFns } from "./CuringReCheckView.vue?vue&type=template&id=3b18f853&scoped=true&"
import script from "./CuringReCheckView.vue?vue&type=script&lang=js&"
export * from "./CuringReCheckView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18f853",
  null
  
)

export default component.exports